"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @hidden */
exports.assert = function (condition, message) {
    if (!condition) {
        throw new Error(message);
    }
};
//# sourceMappingURL=assert.js.map